var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 22.909 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_42",
    "data-name": 42,
    transform: "translate(-2 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5068",
    "data-name": "Path 5068",
    d: "M24.909,14a.812.812,0,0,1-.24.578L16.488,22.76A.818.818,0,1,1,15.331,21.6l7.6-7.6-7.6-7.6A.818.818,0,1,1,16.488,5.24l8.182,8.182a.812.812,0,0,1,.24.578Zm-4.091,0a.812.812,0,0,0-.24-.578L12.4,5.24A.818.818,0,0,0,11.818,5h-9A.818.818,0,0,0,2.24,6.4l7.6,7.6-7.6,7.6A.818.818,0,0,0,2.818,23h9a.818.818,0,0,0,.578-.24l8.182-8.182a.812.812,0,0,0,.24-.578Z",
    transform: "translate(0 0)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.94cc718160c18218fc1134c719fa75ab.svg";
export { ForwardRef as ReactComponent };